import {useEffect} from "react";

/**
 * Executes method on hook / component unmount
 */
export default function useOnUnmount(method: (any?) => any) {
    useEffect(() => () => {
        method()
    }, [])
}